import React from 'react';
import PropTypes from 'prop-types';

class Checkbox extends React.Component {
  onToggle = (e) => {
    const {disabled, checked, value, onChange} = this.props;
    e.stopPropagation();
    if (disabled) return;

    onChange({value, checked: !checked});
  };

  render() {
    const {className, disabled, checked} = this.props;

    return (
      <span className={`Checkbox ${className} ${disabled ? 'nonclickable' : ''}`}>
        <div className={`checkbox relative ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
          <input type='checkbox'
                 disabled={disabled}
                 onClick={this.onToggle}
                 style={{
                   position: 'absolute',
                   top: 0,
                   left: 0,
                   width: '100%',
                   height: '100%',
                   margin: 0,
                   opacity: 0,
                   cursor: disabled ? 'default' : 'pointer'
                 }}
                 ref={(input) => { this.checkbox = input; }} />
        </div>
      </span>
    );
  }
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number
  ])
};

Checkbox.defaultProps = {
  className: ''
};

export default Checkbox;
